// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Ogp5Z","successContainer":"Header_successContainer__-bcYd","img":"Header_img__rWxj2"};